import React, { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import { DateTime } from "luxon";

import { Timezone } from "../../../types/timezone-display";

interface IProps {
  timezone: Timezone;
  dataTestId?: string;
}

const TimezoneClock = ({ timezone }: IProps) => {
  const [currentDateTime, setCurrentDateTime] = useState(
    DateTime.now().setZone(timezone).toFormat("dd MMM yy hh:mm a")
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(
        DateTime.now().setZone(timezone).toFormat("dd MMM yy hh:mm a")
      );
    }, 5000); // Update every 5 seconds (5,000 milliseconds)

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [timezone]);

  return (
    <div>
      <Typography variant="body2">{currentDateTime}</Typography>
    </div>
  );
};

export default TimezoneClock;
